import { render, staticRenderFns } from "./login-instruction.vue?vue&type=template&id=3ae6c013&scoped=true&"
import script from "./login-instruction.vue?vue&type=script&lang=js&"
export * from "./login-instruction.vue?vue&type=script&lang=js&"
import style0 from "./login-instruction.vue?vue&type=style&index=0&id=3ae6c013&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ae6c013",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/stage-dev3/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3ae6c013')) {
      api.createRecord('3ae6c013', component.options)
    } else {
      api.reload('3ae6c013', component.options)
    }
    module.hot.accept("./login-instruction.vue?vue&type=template&id=3ae6c013&scoped=true&", function () {
      api.rerender('3ae6c013', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/auth/login-instruction.vue"
export default component.exports